var map = {
	"./Achievement.json": 21,
	"./Activity.json": 22,
	"./ActivityBalloon.json": 23,
	"./ActivityBanner.json": 24,
	"./ActivityBigBanner.json": 25,
	"./ActivityExchange.json": 26,
	"./ActivityLabel.json": 27,
	"./ActivityLoot.json": 28,
	"./ActivityPVPLv.json": 29,
	"./ActivitySidebar.json": 30,
	"./ActivitySkin.json": 31,
	"./AlbumConfig.json": 32,
	"./AnimAtkFrame.json": 33,
	"./AnimDuration.json": 34,
	"./Artifact.json": 35,
	"./ArtifactPower.json": 36,
	"./ArtifactRank.json": 37,
	"./Astrolabe.json": 38,
	"./AstrolabeTag.json": 39,
	"./AstrolabeTagSetting.json": 40,
	"./Avatar.json": 41,
	"./AvatarFrame.json": 42,
	"./Backflow.json": 43,
	"./BackflowParam.json": 44,
	"./Ban.json": 45,
	"./BattlePass.json": 46,
	"./BattlePassExp.json": 47,
	"./BattlePassRewards.json": 48,
	"./Boss.json": 49,
	"./BossLabel.json": 50,
	"./BossLoot.json": 51,
	"./BossSkin.json": 52,
	"./BountyGossip.json": 53,
	"./BountyLevel.json": 54,
	"./BountyQuest.json": 55,
	"./Challenge.json": 56,
	"./ChallengeTask.json": 57,
	"./Champion.json": 58,
	"./ChampionCfg.json": 59,
	"./ChampionLeague.json": 60,
	"./ChampionLevelRes.json": 61,
	"./ChampionMainRes.json": 62,
	"./ChampionMatch.json": 63,
	"./Charge.json": 64,
	"./ChargeCustomize.json": 65,
	"./ChargeExclPay.json": 66,
	"./ChargeExtra.json": 67,
	"./ChargeFund.json": 68,
	"./ChargeGoods.json": 69,
	"./ChargeSize.json": 70,
	"./ChargeTrigger.json": 71,
	"./ChargeVIPExtra.json": 72,
	"./CommunityUrl.json": 73,
	"./ConjuringReward.json": 74,
	"./ConjuringSeason.json": 75,
	"./ConjuringTrash.json": 76,
	"./ConjuringWeight.json": 77,
	"./CostSet.json": 78,
	"./Currency.json": 79,
	"./DailyLogin.json": 80,
	"./DailyLoginActivityLogin.json": 81,
	"./DataReportUA.json": 82,
	"./Dialog.json": 83,
	"./DialogNPC.json": 84,
	"./Equip.json": 85,
	"./EquipEnhanceItem.json": 86,
	"./EquipEnhancement.json": 87,
	"./EquipJob.json": 88,
	"./EquipQuality.json": 89,
	"./EquipSuit.json": 90,
	"./EquipUnit.json": 91,
	"./ErrorCode.json": 92,
	"./FundRewards.json": 93,
	"./GodBoxEffect.json": 94,
	"./GodBoxLabel.json": 95,
	"./GodBoxReward.json": 96,
	"./GodBoxSkin.json": 97,
	"./GodBoxTrash.json": 98,
	"./GuideFail.json": 99,
	"./Guild.json": 100,
	"./GuildBoss.json": 101,
	"./GuildBossBuffActive.json": 102,
	"./GuildBossChest.json": 103,
	"./GuildBossFinaleReward.json": 104,
	"./GuildBounty.json": 105,
	"./GuildBountyExplore.json": 106,
	"./GuildBountyParam.json": 107,
	"./GuildBountyProcessRewards.json": 108,
	"./GuildBountyRandom.json": 109,
	"./GuildIcon.json": 110,
	"./GuildLog.json": 111,
	"./GuildManorBlock.json": 112,
	"./GuildManorBuilding.json": 113,
	"./GuildManorCellType.json": 114,
	"./GuildManorLevel.json": 115,
	"./GuildMineConfig.json": 116,
	"./GuildMineLog.json": 117,
	"./GuildMineYield.json": 118,
	"./ImpulseGift.json": 119,
	"./Introduction.json": 120,
	"./Item.json": 121,
	"./ItemCompose.json": 122,
	"./Lantern.json": 123,
	"./LegendArenaProperty.json": 124,
	"./Mail.json": 125,
	"./MazeCell.json": 126,
	"./MazeCellType.json": 127,
	"./MazeConfig.json": 128,
	"./MazeMap.json": 129,
	"./Medal.json": 130,
	"./MultiLanguage.json": 131,
	"./OPSubtitle.json": 132,
	"./OPSubtitleVedio.json": 133,
	"./PackageSwitch.json": 134,
	"./Param.json": 135,
	"./ParamBattleMode.json": 136,
	"./ParamCD.json": 137,
	"./ParamCost.json": 138,
	"./ParamExclPayMail.json": 139,
	"./ParamGradient.json": 140,
	"./ParamHiden.json": 141,
	"./ParamInputLength.json": 142,
	"./ParamOpenCondition.json": 143,
	"./ParamPopMode.json": 144,
	"./ParamSceneMode.json": 145,
	"./ParamWeeklyOpen.json": 146,
	"./PentagramGossip.json": 147,
	"./PlatASR.json": 148,
	"./PlayerLevel.json": 149,
	"./Privilege.json": 150,
	"./Pvp.json": 151,
	"./PvpRewards.json": 152,
	"./PvpTopArenaDivision.json": 153,
	"./Raid.json": 154,
	"./RaidAI.json": 155,
	"./RaidActivityConfigure.json": 156,
	"./RaidActivitySkin.json": 157,
	"./RaidBlock.json": 158,
	"./RaidCell.json": 159,
	"./RaidCellType.json": 160,
	"./RaidDisplay.json": 161,
	"./RaidDiyCellList.json": 162,
	"./RaidEffect.json": 163,
	"./RaidEffectGroup.json": 164,
	"./RaidEffectType.json": 165,
	"./RaidFcaList.json": 166,
	"./RaidHeirloom.json": 167,
	"./RaidMap.json": 168,
	"./RaidReward.json": 169,
	"./RaidSprite.json": 170,
	"./RaidSpriteType.json": 171,
	"./RankBoard.json": 172,
	"./RankBoardReward.json": 173,
	"./RegionList.json": 174,
	"./RegionListSetting.json": 175,
	"./Rule.json": 176,
	"./RuleIntroduction.json": 177,
	"./RuleStory.json": 178,
	"./SLGMapCell.json": 179,
	"./SLGMapIdle.json": 180,
	"./SLGMapRandomDebuff.json": 181,
	"./SLGMapRegion.json": 182,
	"./SLGSystemNobility.json": 183,
	"./SLGSystemPicSetting.json": 184,
	"./SLGSystemRelic.json": 185,
	"./SLGSystemRelicQuality.json": 186,
	"./Share.json": 187,
	"./Shop.json": 188,
	"./ShopGoods.json": 189,
	"./ShopGroup.json": 190,
	"./Sidebar.json": 191,
	"./Signature.json": 192,
	"./SignatureLevel.json": 193,
	"./SignaturePower.json": 194,
	"./Skill.json": 195,
	"./SkillBuff.json": 196,
	"./SkillBuffDesc.json": 197,
	"./SkillWeather.json": 198,
	"./Skin.json": 199,
	"./Sound.json": 200,
	"./SoundAnim.json": 201,
	"./SoundBattle.json": 202,
	"./SoundEffect.json": 203,
	"./Stage.json": 204,
	"./StageBattle.json": 205,
	"./StageBattleIndex.json": 206,
	"./StageChapter.json": 207,
	"./StageElfTower.json": 208,
	"./StageHumanTower.json": 209,
	"./StageIdle.json": 210,
	"./StageLevelSuppress.json": 211,
	"./StageOrcTower.json": 212,
	"./StageTower.json": 213,
	"./StageUndeadTower.json": 214,
	"./TaskLine.json": 215,
	"./TaskTodoChest.json": 216,
	"./TaskTodolist.json": 217,
	"./Tavern.json": 218,
	"./TavernAmazingBox.json": 219,
	"./TavernPool.json": 220,
	"./TavernPoolView.json": 221,
	"./TavernStargazerHero.json": 222,
	"./TavernUp.json": 223,
	"./Tips.json": 224,
	"./TipsDialog.json": 225,
	"./TipsLongPress.json": 226,
	"./TopHonor.json": 227,
	"./TrialConfigure.json": 228,
	"./TrialLabel.json": 229,
	"./TrialSkin.json": 230,
	"./Trigger.json": 231,
	"./Troop.json": 232,
	"./TroopArts.json": 233,
	"./TroopType.json": 234,
	"./TutorialStep.json": 235,
	"./Unit.json": 236,
	"./UnitDialog.json": 237,
	"./UnitDisplayLevel.json": 238,
	"./UnitDuty.json": 239,
	"./UnitGS.json": 240,
	"./UnitHero.json": 241,
	"./UnitLevel.json": 242,
	"./UnitPeriod.json": 243,
	"./UnitPortrait.json": 244,
	"./UnitPuppet.json": 245,
	"./UnitQuality.json": 246,
	"./UnitQualityLevel.json": 247,
	"./UnitRank.json": 248,
	"./UnitRankLevel.json": 249,
	"./UnitRes.json": 250,
	"./UnitStoryBook.json": 251,
	"./UnitTag.json": 252,
	"./UnitTexas.json": 253,
	"./VIP.json": 254,
	"./VIPPerkDesc.json": 255,
	"./WorldBossActivityInfo.json": 256,
	"./WorldBossBossParam.json": 257,
	"./WorldBossConfig.json": 258,
	"./WorldBossContributionRewards.json": 259,
	"./WorldBossDamageRewards.json": 260,
	"./WorldBossDayPeriod.json": 261,
	"./WorldBossLineup.json": 262,
	"./WorldBossRankBoard.json": 263,
	"./WorldBossRankRewards.json": 264,
	"./languageDb.json": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;